import { useEffect, useState } from "react";
import { X } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";

import {
  updateParams,
  updateVideoPageState,
} from "../../../Pages/Video/VideoActions";
import { submitRestoreVideo } from "../../SharedActions";
import "../FlaggedModal/FlaggedModal.scss";
import { fetchNavbarStats } from "../../../vyrill-ui-config/layout/sidebar/navbarStatsActions";

const VideoConfirmRestore = () => {
  const [loading, setLoading] = useState(false);
  const [videoPayload, setVideoPayload] = useState([]);
  const dispatch = useDispatch();

  const confirmRestore = useSelector(
    (state) => state.videoPageStates.confirmRestore
  );
  const successfullyRestored = useSelector(
    (state) => state.videoPageStates.successfullyRestored
  );
  const restoreVideosCheckList = useSelector(
    (state) => state.videoPageStates.restoreVideosCheckList
  );
  const tab = useSelector((state) => state.videoParams.tab);
  const videos = useSelector((state) => state.videos);

  const tabNames = { "My Videos": "My Videos", Competition: "Competitors" };
  const restoreIcon =
    require(`@src/assets/images/vyrill/videos/restore.png`).default;

  useEffect(() => {
    setVideoPayload(
      restoreVideosCheckList.map((i) => ({
        video_id: i,
        manufacturer_ids:
          videos.find((j) => j?.video?._id === i)?.video?.manufacturer_ids ||
          [],
      }))
    );
  }, [restoreVideosCheckList]);

  const submitRestore = () => {
    submitRestoreVideo(videoPayload, tab === "Competition")
      .then((response) => {
        if (response) {
          setLoading(false);
          dispatch(updateVideoPageState({ successfullyRestored: true }));
          dispatch(updateParams({ reFetch: true }));
          dispatch(fetchNavbarStats());
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const cancelHandler = () => {
    if (successfullyRestored) {
      dispatch(
        updateVideoPageState({
          successfullyRestored: false,
          confirmRestore: false,
          restoreVideosCheckList: [],
          restoreChecks: false,
        })
      );
    } else {
      dispatch(updateVideoPageState({ confirmRestore: false }));
    }
  };

  return (
    <Modal
      size="sm"
      style={{ maxWidth: "510px" }}
      isOpen={confirmRestore}
      className="ConfirmUnflag modal-dialog-centered"
    >
      <ModalHeader className="justify-content-end">
        <X
          size={30}
          role="button"
          className="closeBtn"
          onClick={cancelHandler}
        />
      </ModalHeader>
      <ModalBody className="p-0">
        {!successfullyRestored ? (
          <>
            <div className="d-flex justify-content-center mb-2 mt-1">
              <h2
                style={{
                  lineHeight: "44px",
                  color: "black",
                  textAlign: "center",
                }}
              >
                Are you sure you want to restore{" "}
                {restoreVideosCheckList.length === 1 ? "this" : "these"} video
                {restoreVideosCheckList.length > 1 && "s"} to “
                {`${tabNames[tab]}`}”?
              </h2>
            </div>
            <div className="d-flex justify-content-between ">
              <Button
                className="video-process-btn"
                size="lg"
                color="outline-primary"
                onClick={() => {
                  dispatch(updateVideoPageState({ confirmRestore: false }));
                }}
              >
                No
              </Button>
              <Button
                className="video-process-btn"
                size="lg"
                color="primary"
                onClick={submitRestore}
                disabled={loading}
              >
                Yes
              </Button>
            </div>
          </>
        ) : (
          <div className="d-flex flex-column justify-content-center py-2">
            <div className="d-flex  justify-content-center">
              <img src={restoreIcon} width={40} alt="" />
            </div>
            <div className="d-flex justify-content-center mt-2">
              <h2
                style={{
                  lineHeight: "44px",
                  color: "black",
                  width: "74%",
                  textAlign: "center",
                }}
              >
                {restoreVideosCheckList.length === 1
                  ? " Your video has"
                  : `${restoreVideosCheckList.length} videos have`}{" "}
                been restored to “{`${tabNames[tab]}`}”
              </h2>
            </div>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default VideoConfirmRestore;
